export default __webpack_public_path__ + "static/media/BILLETERA_ICON_ORG_53.43beb725.png";